<template>
  <div id="app">
    <el-container>
      <el-header>
        <div class="logo" @click="goHome">
          <img src="./assets/img/logo.png" alt="logo" />
        </div>

        <div class="nav-btn-box">
          <div class="nav-menu-btn-area">
            <div class="nav-menu-btn">
              <div class="nav-switch-ico-bar"></div>
              <div class="nav-switch-ico-bar"></div>
              <div class="nav-switch-ico-bar"></div>
            </div>
          </div>
          <input id="navBtn" @click="autoMenu" type="checkbox" />
          <el-menu
            :default-active="defaultActive"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            :router="router"
          >
            <el-menu-item index="/">首页</el-menu-item>
            <el-menu-item index="/news">新闻资讯</el-menu-item>
            <el-menu-item index="/product">产品中心</el-menu-item>
            <el-menu-item index="/case">经典案例</el-menu-item>
            <el-menu-item index="/goin">历思生物</el-menu-item>
            <!-- <el-menu-item index="/download">下载APP</el-menu-item> -->
            <el-menu-item index="/invite">人才招聘</el-menu-item>
            <el-menu-item
              ><a
                class="aStyle"
                target="_Blank"
                href="https://iot.kunming-biotech.com"
                >IoT平台</a
              ></el-menu-item
            >
          </el-menu>
        </div>
      </el-header>
      <el-main>
        <router-view />
      </el-main>

      <div class="footer" v-show="isShow">
        <div class="footer-content">
          <ul class="content-nav">
            <li>
              <div>
                <p>新闻资讯</p>
                <span>公司新闻</span>
                <span>行业动态</span>
              </div>
            </li>

            <li>
              <div>
                <p>产品中心</p>
                <span>介绍视频</span>
                <span>技术持有</span>
                <span>产品状况</span>
              </div>
            </li>
            <li>
              <div>
                <p>历思生物</p>
                <span>企业文化</span>
                <span>资质荣誉</span>
                <span>团队风采</span>
                <span>合作伙伴</span>
              </div>
            </li>
            <li>
              <div>
                <p>联系我们</p>
                <span>传真电话：0592-2283932</span>
                <span
                  >电话：0592-2283132&nbsp; &nbsp; &nbsp; &nbsp;
                  400-004-8820</span
                >
                <span
                  >地址：中国（福建）自由贸易试验区厦门片区湖里大道33号第七层西侧之四号
                </span>
              </div>
            </li>
            <li>
              <div>
                <p>友情链接</p>
                <span>厦门历思科技有限公司</span>
                <span
                  ><a
                    style="color:#fff"
                    target="_blank"
                    href="http://www.lisitech.com/"
                    >http://www.lisitech.com/</a
                  ></span
                >
              </div>
            </li>
          </ul>
          <div class="footer-a">
            <p>
              Copyright 2021-2024
              <a target="_blank" href="https://kunming-biotech.com"
                >kunming-biotech.com</a
              >
              All Rights Reserved 历思生物
            </p>
            <p>
              <a target="_blank" href="http://beian.miit.gov.cn"
                >闽ICP备2020021663号</a
              >
            </p>
          </div>
          <!-- 二维码 -->
          <!-- <img src="./assets/img/ercode.png" alt /> -->
          <!--  底部  -->
        </div>
        <!-- <div class="copyright">
          <span>堃铭版权所有</span>

        </div> -->
      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: true,
      visibleHeight: 200,
      rightPos: 100,
      bottomPos: 100,
    };
  },
  methods: {
    handleSelect(key) {
      // eslint-disable-next-line no-console
      console.log(key);
      if (window.innerWidth <= 865) {
        const item = document.getElementsByClassName("el-menu-demo");

        item[0].style.right = "-711px";
        // item[0].style.width = '0';
      }

      if (key == "lskj") {
        return false;
      }
      // this.isShow = key != '/';//是否显示底部
      // window.console.log(this.isShow);
    },
    autoMenu(value) {
      // eslint-disable-next-line no-console
      console.log(value)
      const item = document.getElementsByClassName("el-menu-demo");
      let width = window.innerWidth;
      // eslint-disable-next-line no-console
      console.log(width)
      if (window.innerWidth <= 865) {
        //尺寸小于865px
        let right = item[0].style.right;
        if (right == "-711px" || right + "1" == 1) {
          item[0].style.right = "0"; //显示
        } else {
          item[0].style.right = "-711px"; //隐藏
        }

        // item[0].style.width = '0';
      }
    },
    goHome() {
      if (this.defaultActive != "/") this.$router.push({ path: "/" });
    },
  },
  mounted() {
    window.onresize = function() {
      let width = window.innerWidth;
      // console.log(width)
      const item = document.getElementsByClassName("el-menu-demo");
      if (width > 865) {
        item[0].style.right = "0"; //显示
      } else {
        item[0].style.right = "-711px"; //隐藏
      }
    };
  },
  watch: {
    $route: function(value) {
      // console.log(value)
      let fullPath = "/" + value.fullPath.split("/")[1];

      // console.log(fullPath)
      if (this.defaultActive != fullPath) {
        // eslint-disable-next-line no-console
        console.log("1");
        this.handleSelect(fullPath);
        switch (fullPath) {
          case "/newsdetails":
            fullPath = "/news";
            break;
          case "/casedetails":
            fullPath = "/case";
            break;
        }
        this.defaultActive = fullPath;
      }
    },
  },
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 100%;
  margin: 0 auto;
  position: sticky;
  top: 0;
  z-index: 3;
  background-color: #fff;
  transition: all 0.3s;

  .logo {
    // width: 280px;
    //padding: 10px;
    img {
      width: 60px;
      line-height: 60px;
    }
  }
}
.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  min-height: 216px;
  // overflow: hidden;
  background-color: #0a0a0a;
  &-content {
    transition: all 0.6s;
    max-width: 1024px;
    margin: 0 auto;
    padding-top: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .content-nav {
      transition: all 0.6s;
      display: inline-block;
      // flex-wrap: wrap;
      // overflow: auto;
      li {
        display: inline-block;
        div {
          display: flex;
          flex-direction: column;
          padding: 0 20px;
          //justify-content: center;
          align-items: flex-start;
          p {
            font-size: 20px;
            color: #fcfbff;
            padding: 10px 0;
          }
          span {
            color: #f7f7f7;
            font-weight: 300;
            padding: 5px 0;
          }
        }
      }
    }
    img {
      width: 170px;
      height: 170px;
      padding: 10px;
    }
  }
  .copyright {
    height: 30px;
    background: #125688;
    span {
      color: #fff;
      line-height: 30px;
    }
  }
}
.el-menu--horizontal > .el-menu-item {
  background: #fff;
}
.el-menu.el-menu--horizontal {
  display: flex;
  flex-wrap: wrap;
  z-index: 3;
  background: #fff;
  border-bottom: none !important;
}
.nav-menu-btn-area {
  display: none;
}
.nav-btn-box .nav-menu-btn-area {
  position: absolute;
  top: 4px;
  right: 2px;
  width: 50px;
  height: 50px;
}
/* line 65, ../sass/style.scss */
.nav-btn-box .nav-menu-btn-area .nav-menu-btn {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 30px;
  height: 30px;
  margin: auto;
  background: transparent;
}
/* line 75, ../sass/style.scss */
.nav-btn-box .nav-menu-btn-area .nav-menu-btn .nav-switch-ico-bar {
  width: 80%;
  border-top: solid 2px;
  margin: 6px auto 0 auto;
}
#navBtn {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 3;
  width: 60px;
  height: 60px;
  opacity: 0;
}
.el-menu-demo {
  right: 0;
}
.el-menu-demo a {
  text-decoration-line: none;
}
.footer-a {
  text-align: center;
  margin: 0 auto;
  font-size: 13px;
  color: rgb(235, 233, 233);
  margin-top: 20px;
  a {
    color: #dfdfdf;
  }
}
@media screen and(max-width:920px) {
  .footer-content {
    justify-content: center;
    .content-nav {
      width: 360px !important;
    }
  }
}
@media only screen and(max-width:865px) {
  .el-menu-demo a {
    position: absolute;
    width: 100%;
    left: 0;
    padding: 0 20px;
  }
  .nav-menu-btn-area {
    display: block !important;
  }
  .el-menu-demo {
    .el-menu-item {
      &:hover {
        background: blue;
      }
      width: 100%;
    }
    // display:none!important;
    position: fixed !important;
    // right: 0;
    right: -711px;
    top: 60px;
    width: 80%;
    // width:0;
    // height:0;
  }
  .el-menu--horizontal > .el-menu-item {
    float: none !important;
  }
  // #navBtn:checked +.el-menu-demo{
  //   // display:block!important;
  //   height:auto;
  //   width:80%;
  //   right:0;

  // }

  // .el-header{
  //   height:121px!important;
  // }
}
.aStyle {
  width: 100%;
  height: 100%;
  display: inline-block;
}
</style>
